<template>
  <div class="party-wrap" ref="partyWrap">
    <!-- 大党委标题 -->
    <header class="party-header">
      <img
        class="party-header_img"
        src="@/assets/images/partyDetail/flag.png"
        :title="party.zoneName"
      />
      <div class="party-header_title">{{ party.zoneName }}</div>
    </header>

    <!-- 简介 -->
    <section class="brief">
      <!-- 地址 -->
      <div class="brief-address" v-if="party.address">
        <i class="iconfont icon-dingweiweizhi"></i>
        <span class="location-info_text">{{ party.address }}</span>
      </div>
      <!-- 简介内容 -->
      <div class="brief-text">{{ party.remark }}</div>
      <!-- 图片 -->
      <div class="brief-img-list">
        <img
          class="brief-img_item"
          v-for="item in party.picList"
          :key="item.id"
          :src="item.picPath"
        />
      </div>
      <!-- 编辑按钮 -->
      <Button class="party-btn" type="warning" @click="briefEdit">编辑</Button>
    </section>

    <!-- 支部书记 -->
    <section class="user-wrap">
      <div class="user-header">{{ shuji.name }}</div>
      <!-- 书记列表 -->
      <div class="user-list" v-if="shuji.value.length">
        <bk-person
          class="user-list_item"
          v-for="item in shuji.value"
          :imgSize="160"
          :key="item.id"
          :user="item"
          @on-edit="onUserEdit(item, dic[0],true)"
          @on-delete="onUserDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有书记时显示添加 -->
      <img
        v-if="!shuji.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button
        v-if="!shuji.value.length"
        class="party-btn"
        type="warning"
        @click="onUserAdd(dic[0],true)"
        >添加</Button
      >
    </section>

    <!-- 其他委员 -->
    <section class="user-wrap">
      <div class="user-header">{{ otherMember.name }}</div>
      <!-- 书记列表 -->
      <div class="user-list" v-if="otherMember.value.length">
        <bk-person
          class="user-list_item"
          v-for="item in otherMember.value"
          :imgSize="160"
          :key="item.id"
          :user="item"
          @on-edit="onUserEdit(item, dic[1])"
          @on-delete="onUserDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有书记时显示添加 -->
      <img
        v-if="!otherMember.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button class="party-btn" type="warning" @click="onUserAdd(dic[1])"
        >添加</Button
      >
    </section>
    <!-- 先锋圈管理员 -->

    <section class="user-wrap" v-if="!isDzz">
      <div class="user-header">{{ admin.name }}</div>
      <!-- 先锋圈管理员列表 -->
      <div class="user-list" v-if="admin.value.length">
        <bk-person
          class="user-list_item"
          v-for="item in admin.value"
          :imgSize="160"
          :key="item.id"
          :user="item"
          @on-edit="onUserEdit(item, dic[2])"
          @on-delete="onUserDelete(item)"
        ></bk-person>
      </div>
      <!-- 没有书记时显示添加 -->
      <img
        v-if="!admin.value.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button
        v-if="!admin.value.length"
        class="party-btn"
        type="warning"
        @click="onUserAdd(dic[2])"
        >添加</Button
      >
    </section>

    <!-- 编辑信息的弹窗 -->
    <form-modal
      :modal="brief_Modal"
      :form-option="brief_option"
      @on-ok="onBriefConfirm"
    ></form-modal>
    <!-- 添加 / 编辑人员弹窗 -->
    <form-modal
      :modal="user_Modal"
      :form-option="user_option"
      @on-ok="onUserConfirm"
      @autocomplete-on-select="onUserSelect"
    ></form-modal>
  </div>
</template>

<script>
import formModal from "@/components/form-modal";
import bkPerson from "./components/person";
/* 设置简介表单 */
function setBriefOption({
  hasOrgType = false,
  orgType = {
    value: "",
    data: []
  },
  name = {
    value: "",
    disabled: false
  },
  brief = {
    value: ""
  },
  map = {
    value: "",
    longitude: "",
    latitude: "",
  },
  uploadImg = {
    imgArr: []
  }
}) {
  let _orgType = {
    type: "select",
    name: "orgType",
    title: "支部类型",
    value: orgType.value,
    data: orgType.data
  };

  let _name = {
    type: "input",
    name: "name",
    title: "支部名称",
    value: name.value,
    disabled: name.disabled
  };
  let _brief = {
    type: "input",
    name: "brief",
    inputType: "textarea",
    title: "支部简介",
    value: brief.value
  };
  let _map = {
    type: "map",
    name: "map",
    title: "支部位置",
    value: map.value,
    longitude: map.longitude,
    latitude: map.latitude
  };

  let _picture = {
    type: "upload-img",
    name: "picture",
    title: "",
    imgNumber: 3,
    imgArr: uploadImg.imgArr
  };
  // 默认四个
  let res = [_name, _map, _brief, _picture];
  // 有支部类型多一个
  if (hasOrgType) res.unshift(_orgType);
  return res;
}

/* 设置人员添加表单 */
// 设置搜索
function setUserName({
  context,
  autoComplete = {
    value: "",
    disabled: false
  },
  type = {
    id: ""
  },
  originData=[]
}) {
  let tmp = {
    type: "auto-complete",
    title: "姓名",
    name: "name",
    value: autoComplete.value,
    disabled: autoComplete.disabled,
    url: context.urlobj.partyList4add,
    originData:originData,
    params: {
      zoneId: context.partyId,
      typeId: type.id,
      userName: "",
      valueRelated: "userName" // 将value赋值到该字段指向的属性
    }
  };
  return tmp;
}
// 设置头像
function setAvatar(src = "") {
  let tmp = {
    type: "avatar",
    name: "avatar",
    title: "头像",
    src: src
  };
  return tmp;
}
// 设置职务
function setJob(value = "", show = true) {
  let tmp = {
    __show: show,
    type: "input",
    name: "job",
    title: "职务",
    value: value
  };
  return tmp;
}
// 设置电话
function setPhone(value = "") {
  let tmp = {
    type: "input",
    name: "phone",
    title: "工作电话",
    inputType: "tel",
    value: value
  };
  return tmp;
}

/* 支部类型对应的字典type */
const DICTYPE = {
  "2": "party_org_user_category",
  "22": "self_party_org_user_category"
};
/**
 * @description 字典对应的组件中的职位类型
 * 支部书记 和 先锋圈管理的职位是固定的，且不显示  其他委员由用户输入决定 显示
 * */
const DICJOB = {
  self_party_org_user_category_1: setJob("支部书记", false),
  self_party_org_user_category_2: setJob(),
  self_party_org_user_category_3: setJob("先锋圈管理员", false),
  self_party_org_user_category_4: setJob(),

  party_org_user_category_1: setJob("支部书记", false),
  party_org_user_category_2: setJob(),
  party_org_user_category_3: setJob("先锋圈管理员", false)
};

export default {
  name: "",
  components: { formModal, bkPerson },
  props: {},
  data() {
    return {
      isShuji:false,
      zoneType: "",
      selfType: "",
      party: {}, // 支部信息
      shuji: {
        // 支部书记
        name: "",
        value: []
      },
      otherMember: {
        name: "",
        value: []
      },
      admin: {
        name: "",
        value: []
      },
      dic: {}, // 用户字典
      orgType: [], // 支部类型
      // 简介
      brief_Modal: {
        value: false,
        title: "编辑"
      },
      brief_option: [],
      // 人员
      user_Modal: {
        value: false,
        title: "编辑"
      },
      user_option: []
    };
  },
  watch: {},
  computed: {
    // 党总支
    isDzz() {
      return this.zoneType === "22" && this.selfType === "22";
    },
    // 党总支分支部
    isDfz() {
      return this.zoneType === "22" && this.selfType === "2";
    },
    // 辖区支部
    isOther() {
      return this.zoneType === "2" && this.selfType === "2";
    }
  },
  methods: {
    /* 党总支详情 */
    getDetail() {
      let url = this.urlobj.getPartyDetail(this.partyId);
      return this.$get(url);
    },
    /* 初始化字典表-添加用户 */
    initDic() {
      let type = DICTYPE[this.zoneType];
      // 查询参数对应的字典表
      let url = this.urlobj.dictionaryList(type);
      return this.$get(url);
    },
    /* 初始化字典-支部类型 */
    initDicOrgType() {
      let url = this.urlobj.dictionaryList("party_org");
      return this.$get(url);
    },
    /* 获取要初始化的接口 */
    getInitCgi() {
      switch (this.zoneType) {
        // 党总支需要的接口
        case "22":
          return [this.getDetail(), this.initDic()];
        // 党总支分支部和其他支部需要的接口
        case "2":
          return [this.getDetail(), this.initDic(), this.initDicOrgType()];
      }
    },
    /* 初始化页面不同的表单信息等 */
    initPage() {
      this.isShuji = false
      this.$showLoading();
      Promise.all(this.getInitCgi())
        .then(res => {
          let [detail, dic, orgType] = res;
          if (
            !detail.isSucceed ||
            !dic.isSucceed ||
            (orgType && !orgType.isSucceed)
          )
            return this.$Message.error(
              detail.message || dic.message || orgType.message
            );
          // 详情
          this.party = detail.rows[0];

          let _point = [this.shuji, this.otherMember, this.admin];

          Object.keys(this.party.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            _point[index].name = item;
            _point[index].value = this.party.userMapList[item];
          });

          // 字典
          this.dic = dic.rows;
          if(this.zoneType == "22"){
            this.dic[0].dicIndex = 4
            this.dic[0].dicType = 'self_party_org_user_category_4'
          }

          // 支部类型
          if (orgType) {
            this.orgType = orgType.rows.map(item => {
              return {
                label: item.dicName,
                value: item.id
              };
            });
          }

          // 初始化页面modal
          this.initModal();
          this.$refs.partyWrap.scroll({
            top: 60,
            left: 0,
            behavior: "smooth"
          });
        })
        .finally(this.$hideLoading);
    },
    // 初始化不同的modal 表单
    initModal() {
      let _party = this.party,
        _address = JSON.parse(_party.coordinate);

      let _map = {
        value: _party.address
      };
      // 如果有值 更新坐标数据
      if (_address) {
        _map = {
          value: _party.address,
          longitude: _address.x,
          latitude: _address.y,
        };
      }
      // 党总支 四个表单项
      let option = {
        name: {
          value: _party.zoneName,
          disabled: false
          //disabled: this.isDzz // 党分支/其他党组织可维护姓名 党总支不可维护
        },
        brief: {
          value: _party.remark
        },
        map: _map,
        uploadImg: {
          imgArr: _party.picList.map(item => {
            return {
              id: item.id,
              picId: item.picId,
              path: item.picPath
            };
          })
        }
      };
      // 分支部 或者 辖区党组织 多个支部类型
      if (this.zoneType === "2") {
        option.hasOrgType = true;
        option.orgType = {
          value: this.party.orgTypeId,
          data: this.orgType
        };
      }
      this.brief_option = setBriefOption(option);
    },

    /* 打开简介编辑 */
    briefEdit() {
      this.brief_Modal.value = true;
    },
    /* 简介信息编辑完成 */
    onBriefConfirm(formOption) {
      let name = formOption.get("name"),
        brief = formOption.get("brief"),
        map = formOption.get("map"),
        picture = formOption.get("picture");

      let url = this.urlobj.party;
      let data = {
        id: this.partyId,
        communityId: this.orgId,
        zoneName: name.value,
        zoneType: this.selfType,
        remark: brief.value,
        picList: picture.imgArr,
        address: map.value,
        coordinate: JSON.stringify({ x: map.longitude, y: map.latitude })
      };
      this.$showLoading();
      this.$post(url, data)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.$Message.success("添加成功");
          this.initPage();

          // 更新list 页面视图
          this.updateList();
        })
        .finally(this.$hideLoading);
    },

    /* 人员弹窗 */
    onUserAdd(dicUser,isShuji=false) {
      this.isShuji=isShuji
      this.user_Modal = {
        value: true,
        title: "添加"
      };
      // 页面当前的操作人员类型
      this.curDicUser = dicUser;
      // 姓名
      let name = setUserName({
        context: this,
        type: {
          id: dicUser.id
        }
      });
      // 头像
      let avatar = setAvatar();
      // 电话
      let phone = setPhone();
      let _option = [name, avatar, phone];

      let job = DICJOB[dicUser.dicType];

      _option.splice(2, 0, job);

      this.user_option = _option;
    },
    /* 人员编辑 */
    onUserEdit(person, dicUser,isShuji=false) {
      this.isShuji = isShuji
      this.user_Modal = {
        value: true,
        title: "编辑"
      };
      this.editPerson = person;
      this.curDicUser = dicUser;

      this.onUserSelect(person, true);
    },
    /* 确认人员信息填写 */
    onUserConfirm(formOption) {
      let user = formOption.get("name"),
        userOrigin = user.originData[0], // 取用户校验用的值
        avatar = formOption.get("avatar"),
        phone = formOption.get("phone"),
        job = formOption.get("job");

      // 编辑模式下更换用户数据来源 以及 跳过校验
      if (user.disabled) {
        userOrigin = this.editPerson;
      }
      if (!user.disabled) {
        // 选取的用户姓名不能编辑 校验
        if (!userOrigin) return this.$Message.warning("用户姓名不存在");

        if (user.value !== userOrigin.userName)
          return this.$Message.warning("用户不在选择列表");
      }

      let url = this.urlobj.partyUser,
        data = {
          zoneId: this.partyId,
          typeId: user.params.typeId,
          unionId: userOrigin.unionId,
          userName: userOrigin.userName,
          headPicUrl: avatar.src,
          phoneNO: phone.value,
          proTitle: job.value
        };
      if(this.zoneType == "22" && this.isShuji) data.typeName = job.value
      // 修改人员 添加参数
      if (user.disabled) {
        data.id = userOrigin.id;
      }
      this.$showLoading();
      this.$post(url, data)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.$Message.success("添加成功");
          this.initPage();

          // 更新list 页面视图
          this.updateList();
        })
        .finally(this.$hideLoading);
    },
    /* 人员搜索 / 人员信息编辑回填*/
    onUserSelect(selected, disabled = false) {
      // 姓名
      let name = setUserName({
        context: this,
        autoComplete: {
          value: selected.userName,
          disabled: disabled
        },
        type: {
          id: this.curDicUser.id
        },
        originData:[selected]
      });
      // 头像
      let avatar = setAvatar(selected.headPicUrl);
      // 电话
      let phone = setPhone(selected.phoneNO);
      let _option = [name, avatar, phone];

      let job = DICJOB[this.curDicUser.dicType];
      _option.splice(2, 0, job);
      _option.forEach(item=>{
        if(item.name == 'job') item.value = selected.proTitle
      })

      this.user_option = _option;
    },
    /* 人员删除 */
    onUserDelete(person) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认要进行删除操作吗？</p>",
        onOk: () => {
          // 执行删除操作
          let url = this.urlobj.partyUserDelete(person.id);
          this.$delete(url).then(res => {
            if (!res.isSucceed) return this.$Message.error(res.message);
            this.$Message.success("删除成功");
            this.initPage(); // 刷新页面

            // 更新list 页面视图
            this.updateList();
          });
        }
      });
    },
    /* 更新 list 页面信息 */
    updateList() {
      // 党总支 刷新人员信息
      if (this.isDzz) this.$bus.$emit("miniParty_personChange");
      // 党分支
      if (this.isDfz) this.$bus.$emit("miniParty_branchPersonChange");
      // 其他分支部
      if (this.isOther) this.$bus.$emit("miniParty_otherPersonChange");
    }
  },
  created() {},
  mounted() {
    this.partyId = this.$route.query.id; // 支部id
    this.orgId = this.$route.query.orgId; // 社区id
    this.selfType = String(this.$route.query.selfType); // 表单和页面类型 22-党总支  2-党总支分部/其他党支部
    this.zoneType = String(this.$route.query.zoneType); // 人员维护 22-党总支/党总支分部  2-其他党支部
    // 初始化页面
    this.initPage();
  }
};
</script>
<style lang="less" scoped>
@marginGap: 0.2rem;
@adderessFontSize: 0.24rem;

.party-wrap {
  .flex(center, @flexDirection:column);
}
/* 头部 */
.party-header {
  .flex(center);
  margin: @marginGap 0;
}
.party-header_img {
  height: 0.7rem;
  width: 0.7rem;
  margin-bottom: -@marginGap;
}
.party-header_title {
  font-family: "KaiTi";
  font-size: 0.48rem;
  font-weight: 600;
  color: transparent;
  background: url("~@/assets/images/partyDetail/orgTitleBg.jpg");
  background-repeat: repeat-x;
  background-clip: text;
  -webkit-background-clip: text;
  max-width: 20em;
}
/* 简介 */
.brief {
  .flex(center, @flexDirection:column);
  max-width: 10rem;
}
.brief-address {
  font-size: 0.24rem;
  color: #666;
  .icon-dingweiweizhi {
    font-size: inherit;
    color: #ff7b44;
  }
}
.brief-text {
  width: 100%;
  color: #333;
  text-align: left;
  font-size: 0.26rem;
  line-height: 2em;
  text-indent: 2em;
}
.brief-img-list {
  .flex(center, @flexWrap:wrap);
  width: 100%;
  margin: 20px 0;
}
.brief-img_item {
  width: 3rem;
  height: auto;
  margin: 0 10px 10px 0;
}

/* 社区书记 */
.user-wrap {
  .flex(center, @flexDirection:column);
  margin-top: 0.6rem;
}
.user-list {
  .flex(flex-start, center, @flexWrap:wrap);
  margin-top: 40px;
  &_item {
    margin: 0 0.4rem;
  }
}
.user-header {
  position: relative;
  font-size: 0.36rem;
  color: #4b4b4b;
  font-weight: bolder;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: translateY(-50%);
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: rotateY(180deg) translateY(-50%);
  }
}
.party-btn {
  padding: 8px 0.3rem;
  font-size: 0.26rem;
  line-height: 1;
  margin-top: @marginGap;
}
.no-person_img {
  width: 3rem;
  height: auto;
}
</style>
